import {
  Alert,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/pages/login.module.scss";
import logo from "../../public/assets/images/logo.svg";
import OtpInput from "react-otp-input";

import { Link, useNavigate, useParams } from "react-router-dom";
import useNotiStack from "../../hooks/useNotistack";
import { useOTPverification } from "../../hooks/useUser";

const Index = () => {
  const [otp, setOtp] = useState("");
  const [confinname, setConfinname] = useState("Confirm");
  const [errormeg, setErrormeg] = useState(false);
  const { email } = useParams();
  const { toastSuccess, toastError } = useNotiStack();
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const params = {};
  for (const [key, value] of urlParams) {
    params[key] = value;
  }

  console.warn(
    "🚀 ~ file: Password_recovery.jsx:40 ~ Index ~ queryString:",
    params?.email
  );
  const { mutate, isSuccess } = useOTPverification();
  const navigate = useNavigate();
  const handleSubmission = (e) => {
    setConfinname("Confirming...");
    e.preventDefault();

    const formData = new FormData();
    formData.append("reset_code", otp);
    formData.append("email", params?.email);

    mutate(formData, {
      onSuccess: (res) => {
        console.warn(res, "sdad22");

        if (res?.message === "OTP is valid") {
          // toastSuccess(res?.data.message);
          navigate(`/Change-Password?email=${params?.email}&reset_code=${otp}`);

          // router.push(
          //   `/resetpassword?email=${params?.email}&reset_code=${otp}`
          // );
        } else {
          // toastError(res?.data.message);
          setErrormeg(true);
        }
      },
    });
  };

  return (
    // <AuthWrapper>
    <Box className={styles.pageLogin}>
      <form>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <Box className={styles.panelLeft}>
              <Link to="/">
                <img src={logo} alt="img" width={140} height={29} />
              </Link>
              <Box className={styles.authContent}>
                <Typography variant="h1">Reset Your Password.</Typography>
                <Typography variant="body1">
                  For optimal security, please follow these guidelines when
                  creating your password:
                </Typography>
                <List>
                  <ListItem>At least 8 characters in length.</ListItem>
                  <ListItem>
                    Contains a mix of letters, numbers, and symbols.
                  </ListItem>
                  <ListItem>
                    Does not include easily guessable information such as your
                    name or username.
                  </ListItem>
                </List>
                <Typography variant="body1">
                  Thanks for helping make your password secure!
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={`${styles.panelRight}`}>
              <Typography variant="h2">
                Please enter the OTP that was sent to your email
              </Typography>
              <Box className={`${styles.formSec} ${styles.forOtp}`}>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={8}
                  inputType="number"
                  renderInput={(props) => (
                    <input {...props} className={styles.otpInput} />
                  )}
                />
                <Button
                  type="submit"
                  className={
                    otp.length !== 8
                      ? styles.btnFullBlack1
                      : styles.btnFullBlack
                  }
                  disabled={!otp}
                  onClick={handleSubmission}
                >
                  {confinname}
                </Button>
                {errormeg && (
                  <Alert severity="error" className={styles.errorAlert}>
                    The OTP you entered is incorrect.
                  </Alert>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
    // </AuthWrapper>
  );
};

export default Index;
